var Frameworks = {
    init: function() {
        Frameworks.bindFrameworkRequest();
        Frameworks.bindLevelsScreenSubjectBoxes();
        Frameworks.bindLevelsSubjectsCheckbox();
        Frameworks.bindAddFramework();
        Frameworks.bindAddSubject();
        Frameworks.bindRemoveSubject();
        Frameworks.bindAddStar();
        Frameworks.bindRemoveStar();
        Frameworks.bindSubjectLevelToggle();
        Frameworks.bindEditStatement();
        Frameworks.bindForms();
        Frameworks.bindDeleteStatement();
        Frameworks.bindSelectStarColour();
        // moved to app.js iniSelect2
        //Frameworks.bindFlightPathSelects();
    },

    bindDeleteStatement:function () {
        $('.delete-statement').click(function() {
            var remove = confirm('Are you sure you want to delete this statement?');

            if (!remove) {
                return false;
            }

            var btn = $(this);
            var frameworkId = btn.data('framework');
            var statementId = btn.data('statement');
            var subject = btn.data('subject');
            var level = btn.data('level');
            var statementsContainer = $('#statements-' + subject + '-' + level);

            $.get('/admin/frameworks/' + frameworkId + '/statements/' + statementId + '/delete', function(data) {
                statementsContainer.html(data);
                Frameworks.bindStatementActions();
            });
        });
    },

    bindStatementActions: function() {
        Frameworks.bindEditStatement();
        Frameworks.bindDeleteStatement();
        App.initSortable();
    },

    bindSubjectLevelToggle: function() {
        $('.subject-level-toggle').click(function() {
            var btn = $(this);
            var subject = btn.data('subject');
            var level = btn.data('level');
            var statementsContainer = $('#statements-' + subject + '-' + level);
            var statements = $('.statement-' + subject + '-' + level);
            //var otherStatements = $('.subject-level-statements');

            if (btn.hasClass('fa-chevron-down')) {
                btn.removeClass('fa-chevron-down').addClass('fa-chevron-up');
                if (statements.length <= 0) {
                    $.get('/statements/ajax?subjectId=' + subject + '&levelId=' + level, function(data) {
                        statementsContainer.html(data);
                        statementsContainer.slideDown('fast');
                        Frameworks.bindStatementActions();
                    });
                } else {
                    statementsContainer.slideDown('fast');
                }
            } else {
                btn.removeClass('fa-chevron-up').addClass('fa-chevron-down');
                statementsContainer.slideUp('fast');
            }
        });
    },

    bindEditStatement: function() {
        $('.edit-statement').off('click').click(function(e) {
            e.stopPropagation();
            var btn = $(this);
            var type = btn.data('type');
            var frameworkId = btn.data('framework');
            var levelId = btn.data('level');
            var subjectId = btn.data('subject');
            var url = '/admin/frameworks/' + frameworkId + '/levels/' + levelId + '/statements/add?subject=' + subjectId;
            var modal = $('#statementModal');
            var modalBody = $('#statementModalBody');

            if (type == 'edit') {
                var statementId = btn.data('statement');
                url = '/admin/frameworks/' + frameworkId + '/statements/'  + statementId + '/edit';
            }

            $.get(url, function(data) {
                modalBody.html(data);
                Frameworks.bindForms();
            });

            modal.modal();
        });
    },

    bindForms: function() {
        $('#statementsFormSubmit').click(function(e) {
            var form = $($('.statement-form')[0]);
            var url = form.attr('action');
            var data = form.serialize();
            var subjectId = $('#subjectInput').val();
            var levelId = $('#levelInput').val();
            var statementsContainer = $('#statements-' + subjectId + '-' + levelId);
            // console.log(statementsContainer);
            // return false;
            //var statementsCount = $('.statement-'  + subjectId + '-' + levelId);

            $.post(url, data, function(res) {
                statementsContainer.html(res);
                $('#statementModal').modal('hide');
                Frameworks.bindStatementActions();
            });
        });
    },

    bindSelectStarColour: function() {
        $('.star-colour-select').select2({
            templateResult: Frameworks.formatColour,
            templateSelection: Frameworks.formatColour
        });
    },

    formatColour: function(state) {
        if (!state.id) {
            return state.text;
        }
        var bar = Array(16).join('&nbsp');
        var $state = $(
            //'<span style="background-color: ' + state.text + '" class="color-label"></span><span>' + state.text + '</span>'
            //'<span class="select2-star-colour-select-container" style="background-color: ' + state.text + '" class="select2-selection__rendered" title=""' + state.text + '">' + state.text + '</span>'
            '<span class="select2-star-colour-select-container" style="background-color: ' + state.text + '" class="select2-selection__rendered" title=""' + state.text + '">' + bar + '</span>'
        );
        return $state;
    },

    bindAddStar: function() {
        $('.add-star').click(function() {
            var count = $('.star').length;
            $.get('/admin/frameworks/stars/ajax?count=' + count, function(data) {
                var stars = $('#stars');
                stars.append(data);
                Frameworks.bindSelectStarColour();
            });
        });
    },

    bindRemoveStar:function() {
        $('.remove-star').click(function(e) {
            var btn = $(this);
            var lastStar = $('.star:last');
            var newStar = lastStar.hasClass('new-star');
            var hasAssessment = lastStar.hasClass('has-assessment');

            if (newStar) {
                lastStar.remove();
                return true;
            }

            var remove = confirm('Are you sure you want to delete this star?');

            if (remove) {
                if (hasAssessment) {
                    var assessmentConfirm = confirm('This star has assessment against it, do you want to delete it anyway?');
                    if (!assessmentConfirm) {
                        return false;
                    }
                }

                var star = lastStar.data('star');
                var schoolString = '';
                var schoolSelect = $('#school');

                if (schoolSelect.length > 0) {
                    schoolString = '?school=' + schoolSelect.val();
                }

                $.get('/admin/frameworks/stars/'+ star +'/remove' + schoolString, function(response) {
                    if (response.success) {
                        alert('Star deleted.');
                        lastStar.remove();
                        return true;
                    }
                    alert('Action not successfuly. Please try again.')
                });
            }
        });
    },

    bindAddSubject: function() {
        $('#streaming-add-subject').click(function() {
            var table = $('#subjects');
            var frameworkId = $('#frameworkId').val();
            $.get('/admin/frameworks/' + frameworkId + '/streaming/ajax', function(data) {
                table.append(data);
                $('.select2').select2();
                Frameworks.bindRemoveSubject();
            })
        });
    },

    bindRemoveSubject: function() {
        $('.delete-subject').click(function(e) {
            var subjectId = $(this).data('subject');
            var frameworkId = $('#frameworkId').val();
            var subjectElement = $('#subject-' + subjectId);

            if (!subjectElement.hasClass('new-subject')) {
                var remove = confirm('Are you sure you want to delete this subject?');
                if (remove) {
                    $.get('/admin/frameworks/' + frameworkId +'/subjects/' + subjectId + '/delete', function() {
                        subjectElement.remove();
                    })
                }
            } else {
                subjectElement.remove();
            }
        });
    },

    bindAddFramework: function() {
        $('.add-framework').click(function() {
            var btn = $(this);
            btn.addClass('disabled-link');
            btn.html('<i class="fa fa-plus"></i> Please wait...')
        });
    },

    bindLevelsScreenSubjectBoxes: function() {
        $('.soladmin-levels-toggle-subject-list').on('click', function() {
            if ($(this).hasClass('fa-chevron-down')) {
                $(this).parents('tr').find('.level-list').show();
                $(this).removeClass('fa-chevron-down').addClass('fa-chevron-up');
            } else {
                $(this).parents('tr').find('.level-list').hide();
                $(this).removeClass('fa-chevron-up').addClass('fa-chevron-down');
            }
        });
    },

    bindFrameworkRequest: function() {
        $('.request-assessment-framework').on('click', function(e) {
            e.preventDefault();
            alert('This assessment framework may be restricted to certain schools or requires a purchase fee. Please email us to find out more.');
        });
    },

    bindLevelsSubjectsCheckbox: function() {
        $('.level_subject_toggle').on('change', function () {
            var subjectId = $(this).data('subject-id');
            var levelId = $(this).data('level-id');
            var frameworkId = $(this).data('framework-id');
            $.ajax({
                url: '/admin/frameworks/' + frameworkId + '/subject/' + subjectId + '/level/' + levelId + '/toggle',
            });
        });
    },

    bindFlightPathAdd: function() {
        $('#flight-path-add').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            $('.progression-error').hide();
            $('.progression-success').hide();
            $('#flightPathProgress').show();

            var datastring = $("#predictions-form").serialize();
            $.ajax({
                type: "POST",
                url: $(this).data('route'),
                data: datastring,
                dataType: "json",
                success: function(data) {
                    $('#flightPathProgress').hide();
                    $('.progression-success').show();
                },
                error: function(data) {
                    $('#flightPathProgress').hide();
                    $('.progression-error').show();
                }
            });
        });
    },

    bindFlightPathSelects: function() {
        $('.flightpath-level-steps').select2({
            ajax: {
                url: function (args) {
                    return '/admin/frameworks/level-steps/' + $(this.context).data('subject');
                },
                placeholder: 'Find Level',
                dataType: 'json',
                delay: 0,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 1
        });

    },

};